window.onload = function () {
	const btn = document.getElementById('button');
	if (btn) {
		document.getElementById('button').onclick = function () {
			document.getElementById('modalOverlay').style.display = 'none';
		};
	}
};
